
const slbcstatus = {
  label: "Slbc Consolidated Status",
  starting: true,
  url: "slbcstatus",
  pageLabel: "Slbc Consolidated Status",
  pageType: "history",
  filter: [



  ],
  form: [],
  history: {
    perPage: 10,
    reportHeader: "Slbc Consolidated Status",
    pdfProps: { pageSize: "A3", pageOrientation: "landscape" },
    filterable: true,
    sortable: true,
    defaultsTo: 0,


    pivot: true,
    extraRows: {
      location: "top",
      fields: ["slbc_block_display", "slbc_aadhaar_authentications", "slbc_atms", "slbc_branches", "slbc_deposits",
        "slbc_banking_outlets", "slbc_fi_and_kccs", "slbc_nrlms", "slbc_suis", "slbc_acp_disbursements", "slbc_govt_sponsored_recoveries",
        "slbc_kcc_for_fishries", "slbc_nulm_disbursements", "slbc_suraksha_bimas", "slbc_acp_npa_outstandings", "slbc_investment_credit_disbursements"
        , "slbc_kccs", "slbc_priority_sector_loan_to_weakers", "slbc_total_advances", "slbc_acp_outstandings",
        "slbc_digital_transactions", "slbc_investment_credit_outstandings", "slbc_minority_disbursements", "sblc_sc_sts",
        "slbc_womens", "slbc_education_loans", "slbc_jlgs", "slbc_minority_outstandings"],
      subtotals: {
        by: "bank_display",
        displayIn: "slbc_block_display",


      },
      grandtotal: { type: "fixed", displayIn: "slbc_block_display", val: "Grand Total", count: true },
    },
    displayColumns: [
      {
        Header: "Sr", type: "autoinc", accessor: "srno", align: "center", width: 30,
        width132: { size: 3 }//3
      },
      {
        Header: "Block Name",
        accessor: "slbc_block_display",


      },
      {
        Header: "Aadhaar Authentications",
        accessor: "slbc_aadhaar_authentications",

      },
      {
        Header: "Atms",
        accessor: "slbc_atms",

      },
      {
        Header: "Branches",
        accessor: "slbc_branches",

      },
      {
        Header: "Deposits",
        accessor: "slbc_deposits",

      },
      {
        Header: "Banking Outlets",
        accessor: "slbc_banking_outlets",

      },
      {
        Header: "Fi And KCCs",
        accessor: "slbc_fi_and_kccs",

      },
      {
        Header: "NRLMS",
        accessor: "slbc_nrlms",

      },
      {
        Header: "SUIS",
        accessor: "slbc_suis",

      },
      {
        Header: "ACP Disbursements",
        accessor: "slbc_acp_disbursements",

      },
      {
        Header: "Govt Sponsored Recoveries",
        accessor: "slbc_govt_sponsored_recoveries",

      },
      {
        Header: "KCC For Fishries",
        accessor: "slbc_kcc_for_fishries",

      },
      {
        Header: "NULM Disbursements",
        accessor: "slbc_nulm_disbursements",

      },
      {
        Header: "Suraksha Bimas",
        accessor: "slbc_suraksha_bimas",

      },
      {
        Header: "ACP NPA Outstandings",
        accessor: "slbc_acp_npa_outstandings",

      },
      {
        Header: "Investment Credit Disbursements",
        accessor: "slbc_investment_credit_disbursements",

      },
      {
        Header: "KCCs",
        accessor: "slbc_kccs",

      },
      {
        Header: "Priority Sector Loan To Weakers",
        accessor: "slbc_priority_sector_loan_to_weakers",

      },
      {
        Header: "Total Advances",
        accessor: "slbc_total_advances",

      },
      {
        Header: "ACP Outstandings",
        accessor: "slbc_acp_outstandings",

      },
      {
        Header: "Digital Transactions",
        accessor: "slbc_digital_transactions",

      },
      {
        Header: "Investment Credit Outstandings",
        accessor: "slbc_investment_credit_outstandings",

      },
      {
        Header: "Minority Disbursements",
        accessor: "slbc_minority_disbursements",

      },
      {
        Header: "SC STS",
        accessor: "sblc_sc_sts",

      },
      {
        Header: "Womens",
        accessor: "slbc_womens",

      },
      {
        Header: "Education Loans",
        accessor: "slbc_education_loans",

      },
      {
        Header: "JLGS",
        accessor: "slbc_jlgs",

      },
      {
        Header: "Minority Outstandings",
        accessor: "slbc_minority_outstandings",

      }


    ]
  }
};

export default slbcstatus;